module.exports = __webpack_public_path__ + "font/jsoneditor-icons.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-json-editor/assets/img/jsoneditor-icons.svg
// module id = 52
// module chunks = 0